import { ModuleManager, SectionList } from "@module-system";
import CommonConditions from "@lib/commonConditions";

import ScreenShooterBtn from "./Components/ScreenShooterBtn.vue";
import ScreenShooterModal from "./Components/ScreenShooterModal.vue";
import ScreenShooterBridge from "./Components/ScreenShooterBridge.vue";
import configurationProvider from "@/Core/configurationProvider";

import locales from "./locales";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "ScreenShooter",
  version: "1.0.0",
  register() {
    const screenShooterSettings = configurationProvider.getObject("SCREEN_SHOOTER_SETTINGS", { isScreenShooterEnabled: true });

    ModuleManager.addLocales(locales, "ScreenShooter");

    if(!screenShooterSettings.isScreenShooterEnabled) {
      return;
    }

    ModuleManager.addViewModule({
      key: "ScreenShooterBtn",
      section: SectionList.CallButtonsList,
      ViewComponent: ScreenShooterBtn,
      Condition: (rtcId) => {
        return CommonConditions.isAgent() || CommonConditions.isSupervisor;
      }
    });

    ModuleManager.addViewModule({
      key: "ScreenShooterModal",
      section: SectionList.CallModal,
      ViewComponent: ScreenShooterModal,
    });

    ModuleManager.addViewModule({
      key: "ScreenShooterBridge",
      section: SectionList.CallModal,
      ViewComponent: ScreenShooterBridge,
      Condition: (rtcId) => CommonConditions.isAgent(),
    });
  },
};
export default module;